import React from 'react';
import {
  AbsoluteFill,
  useCurrentFrame,
  useVideoConfig,
  interpolate,
} from 'remotion';

export const LiquidDistortion: React.FC = () => {
  const frame = useCurrentFrame();
  const { width, height } = useVideoConfig();

  // 液体扭曲效果 - 使用 SVG 滤镜
  const turbulenceBaseFrequency = 0.015 + Math.sin(frame * 0.02) * 0.005;
  const displacementScale = 30 + Math.sin(frame * 0.05) * 10;

  // 文字颜色动态变化
  const textHue = (frame * 2) % 360;

  return (
    <AbsoluteFill
      style={{
        backgroundColor: '#1a0a2e',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <svg width={width} height={height}>
        <defs>
          {/* 液体扭曲滤镜 */}
          <filter id="liquidDistort">
            <feTurbulence
              type="fractalNoise"
              baseFrequency={turbulenceBaseFrequency}
              numOctaves="3"
              result="noise"
              seed={frame * 0.1}
            />
            <feDisplacementMap
              in="SourceGraphic"
              in2="noise"
              scale={displacementScale}
              xChannelSelector="R"
              yChannelSelector="G"
            />
            <feGaussianBlur stdDeviation="1" />
          </filter>

          {/* 发光效果 */}
          <filter id="glow">
            <feGaussianBlur stdDeviation="4" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* 背景装饰层 */}
        {[...Array(5)].map((_, i) => {
          const x = width / 2 + Math.cos(frame * 0.02 + i) * 150;
          const y = height / 2 + Math.sin(frame * 0.02 + i) * 150;
          return (
            <circle
              key={i}
              cx={x}
              cy={y}
              r={50 + i * 20}
              fill="none"
              stroke={`hsl(${(textHue + i * 60) % 360}, 70%, 50%)`}
              strokeWidth="2"
              opacity={0.2}
              filter="url(#liquidDistort)"
            />
          );
        })}

        {/* 主文字 */}
        <text
          x={width / 2}
          y={height / 2}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="100"
          fontWeight="bold"
          fill={`hsl(${textHue}, 80%, 60%)`}
          filter="url(#liquidDistort)"
          style={{
            fontFamily: 'Arial, sans-serif',
          }}
        >
          LIQUID
        </text>

        {/* 副文字 */}
        <text
          x={width / 2}
          y={height / 2 + 120}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="60"
          fontWeight="bold"
          fill={`hsl(${(textHue + 180) % 360}, 80%, 60%)`}
          filter="url(#liquidDistort)"
          opacity={0.8}
        >
          DISTORTION
        </text>

        {/* 装饰粒子 */}
        {[...Array(30)].map((_, i) => {
          const angle = (i / 30) * Math.PI * 2 + frame * 0.02;
          const radius = 300 + Math.sin(frame * 0.05 + i) * 50;
          const x = width / 2 + Math.cos(angle) * radius;
          const y = height / 2 + Math.sin(angle) * radius;

          return (
            <circle
              key={i}
              cx={x}
              cy={y}
              r={3 + Math.sin(frame * 0.1 + i) * 2}
              fill={`hsl(${(textHue + i * 12) % 360}, 80%, 60%)`}
              opacity={0.6}
              filter="url(#glow)"
            />
          );
        })}
      </svg>

      {/* 说明文字 */}
      <div
        style={{
          position: 'absolute',
          bottom: 60,
          fontSize: 20,
          color: '#999',
          opacity: interpolate(frame, [30, 60], [0, 1], { extrapolateLeft: 'clamp' }),
        }}
      >
        SVG Filter: feTurbulence + feDisplacementMap
      </div>
    </AbsoluteFill>
  );
};
